import { connectSocket, disconnectSocket } from '@/api/socket'

export interface storeOptsType {
	modules: any;
	state: any;
	mutations: any;
	actions: any;
	getters: any;
}

export const modules = {

}
export const state = function () {
	return {
		analyzedResult: [],
		acpointValue: [],
		deviceStatus: [],
		acpointAlarm: [],
		protocolFrame: null,
		softwareUpgrade: null,
		// 连接状态标志（不再把 STOMP 客户端实例放进响应式 state）
		socketConnected: false,
	}
}

// mutations 仅做同步、纯粹的状态赋值
export const mutations = {
	setSocketConnected(state: any, connected: boolean) {
		state.socketConnected = connected
	},
	// 根据推送 action 更新对应业务数据
	applySocketMessage(state: any, body: any) {
		switch (body.action) {
			// 订阅隐患推送
			case 'patrol.result.analyzed': {
				const { action, ...others } = body
				state.analyzedResult = others
				break
			}
			case 'front.acpoint.alarm':
				if (body.data && Array.isArray(body.data)) {
					state.acpointAlarm = [...body.data]
				}
				break
			case 'front.acpoint.value':
				state.acpointValue = body.data
				break
			case 'front.acdevice.status':
				state.deviceStatus = body.data
				break
			case 'protocol_frame':
				state.protocolFrame = body.message
				break
			case 'device.upgrade.status':
				state.softwareUpgrade = body.data
				break
		}
	},
}

export const actions = {
	// 建立连接并订阅数据；断线重连由 socket 模块内置机制处理
	subscribeData({ commit }) {
		connectSocket({
			onMessage: (body) => commit('applySocketMessage', body),
			onStatusChange: (connected) => commit('setSocketConnected', connected),
		})
	},
	// 断开连接
	unsubscribeData({ commit }) {
		disconnectSocket()
		commit('setSocketConnected', false)
	},
}

export const getters = {

}



export const storeOpts: storeOptsType = {
	modules,
	state,
	mutations,
	actions,
	getters,
}
